import React from "react";
import { connect } from "react-redux";
import { string, func, bool, arrayOf, shape } from "prop-types";
import TextInput from "@shared/v2/TextInput/TextInput";
import ContactInfoCard from "../component/ContactInfoCard";
import Contacts from "../component/Contacts";

const SellerContactInformation = ({
  setComments,
  comments,
  agent,
  agentAvatar,
  addSellers,
  setAddSellers,
  sellers,
  setSellers,
  newSellers,
  setNewSellers,
  title,
  useCustomTitle,
  streetAddress,
  city,
  locality,
  postalCode,
}) => (
  <div>
    <div className="tw-py-[32px]">
      <div className="tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-75">
        New Listing (Pre-contract)
      </div>
      <div className="tw-pt-[5px] tw-text-14px tw-leading-[20px] tw-font-normal tw-text-gray-75">
        Please confirm the Primary Agent, Seller(s), and property address. Blueprint will return findings
        within 1-4 business days.{" "}
        <span
          className="tw-cursor-pointer tw-text-semantic-blue-110"
          onClick={() =>
            window.open("https://www.brivityknowledge.com/docs/blueprint-title-integration", "_blank")
          }
        >
          Learn More
        </span>
        <div className="tw-pt-[20px]">
          <div className=" tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-50">
            Listing Street Address
          </div>
          <div className=" tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-75">
            {useCustomTitle ? title || "Custom Transaction Title" : streetAddress}
          </div>
          <div className=" tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-75">
            {useCustomTitle && streetAddress ? `${streetAddress},` : ""} {city ? `${city},` : ""} {locality}{" "}
            {postalCode}
          </div>
        </div>
      </div>
    </div>
    <div>
      <div className="tw-pb-[9px] tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-50">
        <span className="tw-capitalize">Primary Agent</span>
      </div>
      <ContactInfoCard
        name={agent || "No primary agent"}
        avatarImg={agentAvatar}
        role={agent ? "Primary Agent" : ""}
      />
    </div>
    <div className="tw-pt-[28px]"></div>
    <Contacts
      setAddContact={setAddSellers}
      addContact={addSellers}
      newContacts={newSellers}
      setNewContacts={setNewSellers}
      setContact={setSellers}
      contacts={sellers}
      contactType="seller"
    />

    <div className="tw-pt-[28px]"></div>
    <TextInput
      label="Comments"
      className="!tw-w-[554px]"
      multiline
      value={comments}
      rows={5}
      name="comments"
      placeholder="Anything else you'd like Blueprint to know about this title?"
      onChange={(e) => {
        setComments(e.target.value);
      }}
    />
  </div>
);

const mapStateToProps = (state) => ({
  agent: state.tdpDetailsReducer.primaryAgentDetails?.agent,
  agentAvatar: state.tdpDetailsReducer.primaryAgentDetails?.agentAvatar,
  title: state.tdpDetailsReducer.transactionDetails.title,
  useCustomTitle: state.tdpDetailsReducer.transactionDetails.use_custom_title,
  streetAddress: state.tdpDetailsReducer.propertyDetails.street_address,
  city: state.tdpDetailsReducer.propertyDetails.city,
  locality: state.tdpDetailsReducer.propertyDetails.state,
  postalCode: state.tdpDetailsReducer.propertyDetails.zip,
});

SellerContactInformation.propTypes = {
  agent: string,
  agentAvatar: string,
  setAddSellers: func,
  setComments: func,
  comments: string,
  addSellers: bool,
  sellers: arrayOf(shape({})),
  setSellers: func,
  newSellers: arrayOf(shape({})),
  setNewSellers: func,
  streetAddress: string,
  city: string,
  locality: string,
  postalCode: string,
  title: string,
  useCustomTitle: bool,
};

SellerContactInformation.defaultProps = {
  agent: "",
  agentAvatar: null,
  setComments: null,
  comments: "",
  setAddSellers: null,
  addSellers: false,
  sellers: [],
  setSellers: null,
  newSellers: [],
  setNewSellers: null,
  streetAddress: "",
  city: "",
  locality: "",
  postalCode: "",
  title: "",
  useCustomTitle: false,
};

export default connect(mapStateToProps)(SellerContactInformation);
